export default __webpack_public_path__ + "static/media/gallery_10.363589a5.jpg";